import styled from 'styled-components'
import { colors } from '../../../../../../shared/styles/colors'

export const ContainerCards = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  height: 100%;
  margin: 20px 30px;

  @media (max-height: 1080px) {
    height: 400px;
    flex: 1;
  }
`

export const Divider = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  border: 0.5px solid ${colors.lightGrey};
`
